import { Stack, TableCell, TableHead, TableRow } from "@mui/material";
import { ReactComponent as IconGenericDocIcon } from "assets/images/icons/generic-doc-icon.svg";
import { ReactComponent as EditIcon } from "assets/images/square-buttons/edit-line.svg";
import { ReactComponent as ViewIcon } from "assets/images/square-buttons/more.svg";
import { ReactComponent as TrashIcon } from "assets/images/square-buttons/squared-trash.svg";
import Tooltip from "components/Tooltip";
import SortButton from "containers/Members/SortButton";
import { stringToColor } from "helpers/utils";
import { useNavigate } from "react-router-dom";

export const TableHeader = ({ sortingCallback, pageParams }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell align="left"></TableCell>
        <TableCell align="left">
          <SortButton
            label="Protocol Name"
            value="TITLE"
            sortingCallback={sortingCallback}
            pageParams={pageParams}
          />
        </TableCell>
        <TableCell align="left">
          <SortButton
            label="Type"
            value="PROTOCOL_TYPE"
            sortingCallback={sortingCallback}
            pageParams={pageParams}
          />
        </TableCell>
        <TableCell align="right">Actions</TableCell>
      </TableRow>
    </TableHead>
  );
};

export const TableItem = ({ data, index, editCallback, deleteCallback }) => {
  const navigate = useNavigate();

  return (
    <TableRow key={`row${index}`}>
      <TableCell align="left">
        <Stack direction={"row"} alignItems="center">
          <span
            style={{ backgroundColor: stringToColor(data.title) }}
            className={"rounded-circle member-icon"}
          >
            <IconGenericDocIcon width={24} height={24} stroke={"#fff"} />
          </span>
        </Stack>
      </TableCell>
      <TableCell align="left" className="bold black" width="40%">
        {data.title}
      </TableCell>
      <TableCell align="left" className="bold black description-text" width="40%">
        {data.is_fitlinxx_standard ? `FitLinxx Standard` : `Facility Defined`}
      </TableCell>
      <TableCell align="right" width="20%">
        <div className={"buttons-bar"}>
          {!data.is_fitlinxx_standard && (
            <Tooltip content={"Delete"} direction="bottom">
              <button onClick={() => deleteCallback(data.id)}>
                <TrashIcon />
              </button>
            </Tooltip>
          )}
          {!data.is_fitlinxx_standard && (
            <Tooltip content={"Edit"} direction="bottom">
              <button onClick={() => editCallback(data.id)}>
                <EditIcon />
              </button>
            </Tooltip>
          )}
          <Tooltip content={"View"} direction="bottom">
            <button onClick={() => navigate(`/workout-templates/protocols/${data.id}`)}>
              <ViewIcon />
            </button>
          </Tooltip>
        </div>
      </TableCell>
    </TableRow>
  );
};
